<template>
    <div class="aid-container">
        <h4>Spaces aus Vorlage laden</h4>
        <div class="grey-container">
            <div class="top-bar">
                <InputSearch placeholder="Suche" v-model="searchValue" width="230px"></InputSearch>
                <AdaButton style="margin-left: auto" title="REFRESH" type="createButton blue"
                           @click="refresh()"></AdaButton>
            </div>
            <AdaDatatable v-if="!loading" style="margin-bottom: 20px" :columns="columns" :data="spaces"
                          :disable-pagination="true" :show-search="false" :size-of-page="10000"
                          @rowClicked="cellClicked" :search-value="searchValue" :scroll="true"
                          :transformers="transformers"/>
            <div v-if="loading" class="loaderContainer">
                <dot-loader id="loader"></dot-loader>
            </div>
            <AdaButton title="HINZUFÜGEN" type="createButton" @click="addClicked"
                       style="width: fit-content"></AdaButton>
        </div>
    </div>
</template>

<script>
    import AdaButton from "../../../components/buttons/AdaButton";
    import Transformers from "../../../components/tables/Transformers";
    import AdaDatatable from "../../../components/tables/AdaDatatable";
    import InputSearch from "../../../components/inputs/InputSearch";

    export default {
        components: {
            AdaButton,
            AdaDatatable,
            InputSearch
        },
        props: {
            initialSpaces: {
                required: false,
                default: []
            },
            forceReload: {
                required: false,
                default: true
            }
        },
        data: function () {
            return {
                loading: false,
                searchValue: '',
                selectedSpaces: [],
                columns: [
                    {
                        viewName: 'Space',
                        propName: 'name',
                        sortable: true,
                        width: '40%',
                    },
                    {
                        viewName: 'Technischer Name',
                        propName: 'technical_name',
                        sortable: true,
                        width: '40%',
                    },
                    {
                        viewName: 'Erstellungsdatum',
                        propName: 'created_at',
                        sortable: true,
                        width: '20%'
                    }
                ],
                transformers: [
                    {
                        propName: 'name',
                        transform: function (value, row) {
                            let checked = '';
                            if (row.selected) {
                                checked = 'checked disabled';
                            }
                            let res = '<div style="cursor: pointer; user-select: none"><input style="cursor: pointer" id="'
                                + row.id + '" data-type="select" type="checkbox"' + checked + '> <label style="cursor: pointer">' + value + '</label></div>';
                            return res;
                        }
                    },
                    {
                        propName: 'created_at',
                        transform: Transformers.dateTransformer
                    }
                ],
            }
        },
        name: "SelectSpacesFromTable",
        mounted() {
            this.fetchSpaces();
        },
        computed: {
            spaces() {
                const data = this.$store.state.spaces.templateSpaces;
                for (let i = 0; i < data.length; i++) {
                    data[i].selected = false;
                }
                data.forEach(space => {
                    this.initialSpaces.forEach(initial => {
                        if (space.id === initial.id) {
                            space.selected = true;
                            this.selectedSpaces.push(space);
                        } else if (typeof space.selected === 'undefined') {
                            space.selected = false;
                        }
                    })
                });
                return data;
            }
        },
        methods: {
            cellClicked: function (data) {
                data.row.selected = !data.row.selected;
                for (let i = 0; i < this.spaces.length; i++) {
                    if (this.spaces[i].id === data.row.id) {
                        if (!document.getElementById(data.row.id).disabled) {
                            this.spaces[i].selected = data.row.selected;
                            document.getElementById(data.row.id).checked = data.row.selected;
                        }
                    }
                }
            },
            refresh() {
                this.fetchSpaces();
            },
            async fetchSpaces() {
                this.loading = true;
                await this.$store.dispatch('spaces/fetchTemplateSpaces', this.forceReload);
                this.loading = false;
            },
            addClicked() {
                const selectedSpaces = this.getSelectedSpaces();
                this.$emit('selected', selectedSpaces);
            },
            getSelectedSpaces() {
                return this.spaces.filter(space => space.selected);
            }
        }
    }
</script>

<style lang="scss" scoped>

    h4 {
        margin-top: 0;
    }

    .top-bar {
        background-color: white;
        padding: 10px;
        display: flex;
        align-items: center;
    }

    .inter-xxl {
        width: 250px;
        margin-right: 16px;
        margin-bottom: 16px;
    }

    .small-headline-container {
        display: flex;
        flex-direction: row;
        margin-bottom: 30px;
        font-size: 10px;
    }

    .small-headline {
        color: $grey;
    }

    hr {
        margin-left: 6px;
        color: black;
        border: solid $grey 1px;
        height: 1px;
        width: 100%;
    }

    .aid-container {
        padding: 0 10px 10px 10px;
        width: 100%;
    }

    .grey-container {
        background-color: $lightGrey;
        padding: 16px;
    }

    .interactions-container {
        max-height: 40vh;
        overflow-y: scroll;
        margin-bottom: 30px;
    }

    .interactions-container {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
    }

    .loaderContainer {
        height: 40vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    ::v-deep .ada-table-container tr {
        display: flex;
    }

    ::v-deep .ada-table-container td {
        display: block;
    }

</style>